<animate-on-scroll [elements]="elementsToAnimate" [offset]="-50" [startDelay]="5000" [staggerDelay]="200" [animateOnce]="true">
    <via-infographics>
        <div class="e-infographics-layout">

            <h1 class="e-page-title e-coming-soon">Coming soon</h1>
            <h1 class="e-page-title">Search the Via database</h1>
            <p class="e-page-subtitle">Browse over 50 million SKUs from the world's biggest suppliers, brands, and retailers.</p>

            <div class="e-keyword-search-example">
                <img src="/assets/images/info-graphics/search/keyword-search-animation.gif" alt="Animated keyword search functionality example" />
            </div>

            <div class="e-infographic">
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-right" data-anim-delay="0.35s" #animate>
                            <h3>More SKUs than ever</h3>
                            <p>
                                Our database is home to over 50 million SKUs. We are constantly updating and adding to our SKU
                                data about price history, availability, promotions, ratings, product attributes and ingredients,
                                images and so much more.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/search/sku-database.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-left" data-anim-delay="0.35s" #animate>
                            <h3>Instantly matching your search</h3>
                            <p>
                                Euromonitor's automated search sorts through millions of SKUs and related information in our
                                database index to find the most relevant and useful results for what you're looking for in a
                                fraction of a second.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/search/sku-search.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-right" data-anim-delay="0.35s" #animate>
                            <h3>Find exactly what you're looking for</h3>
                            <p>
                                Refine your search results even further with our unique taxonomy and easy-to-use filters. Once
                                you are happy with the results, you can view the price history of the relevant SKUs or configure
                                and export the data in either CSV or Excel format.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/search/filters.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-left" data-anim-delay="0.35s" #animate>
                            <h3>In-depth SKU data and custom sets</h3>
                            <p>
                                See more data behind each SKU with our new SKU Capsule 360. Gain insights like price history,
                                promotions, availability, and ratings. You can also select individual SKUs and create custom SKU
                                sets which can be loaded from your profile.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/search/sku-data-and-sets.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-right" data-anim-delay="0.35s" #animate>
                            <h3>Continuous improvements to give you the best experience</h3>
                            <p>
                                We know that searching can always be improved. That's why we continuously refine and update our
                                data and data infrastructure, resulting in countless improvements, all of which are rigorously
                                tested by our teams.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/search/user-experience.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </via-infographics>
</animate-on-scroll>
